import { useTranslation } from 'react-i18next';
import React from "react";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import { useStockCheckModel } from "../stockCheckModel";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"
import useGlobalModel from "@/erp_subpackage/model/globalModel";

export function PageHeader() {
    const { t } = useTranslation();
    const { getSelectedDictOne } = useDictModel(() => []);
    const { whDs, orgDs } = useGlobalModel(({ whDs, orgDs }) => [whDs, orgDs]);

    const {
        searchParam, organType,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStockCheckModel();

    const searchFields = [
        ...(organType ? [{
            type: "Select",
            placeholder: t(`stock.view.PageHeader.所属机构`),
            fieldName: "shopId",
            options: orgDs
        }] : []),
        {
            type: "Input",
            placeholder: t(`stock.view.PageHeader.盘库单号`),
            fieldName: "stocktakingCode",
        },
        {
            type: "Select",
            placeholder: t(`stock.view.PageHeader.盘点状态`),
            fieldName: "status",
            mode: "multiple",
            options: getSelectedDictOne(DictCodeEnmu.STOCKTAKING)
        },
        {
            type: "Select",
            placeholder: t(`stock.view.PageHeader.盘点仓库`),
            fieldName: "warehouseCode",
            options: whDs,
        },
        {
            type: "RangePicker",
            fieldName: "",
            placeholder: [t(`stock.view.PageHeader.制单日期起始`), t(`stock.view.PageHeader.制单日期结束`)],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
        {
            type: "Select",
            placeholder: t(`stock.view.PageHeader.盘点结果`),
            fieldName: "result",
            options: [{ label: t(`stock.view.PageHeader.盘盈`), value: t(`stock.view.PageHeader.盘盈`) }, { label: t(`stock.view.PageHeader.盘亏`), value: t(`stock.view.PageHeader.盘亏`) }, { label: t(`stock.view.PageHeader.相符`), value: t(`stock.view.PageHeader.相符`) }],
        },
    ]

    return (
        <YhPageHeader
            title={t(`stock.view.PageHeader.库存盘点`)}
            size="small"
            triggerSearch
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData({ pageNum: 1 }, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}